import '../css/Dashboardpage.css';
import DocumentRequest from '../model/request/Documentrequest';
import DocumentstatusResponse from '../model/response/DocumentstatusResponse';
import { Oval } from "react-loader-spinner";
import { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';

function Documentpopup({
    userData,
    documentList = [],
    onClose,
    onRefresh
}) {

    // =====================================================
    // LOGIN DETAILS
    // =====================================================

    const rawVal = localStorage.getItem('loginVal');
    const loginVal = rawVal ? JSON.parse(rawVal) : null;
    const token = loginVal ? loginVal.token : null;

    // =====================================================
    // STATE
    // =====================================================

    const [profile, setProfile] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // =====================================================
    // TOAST
    // =====================================================

    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    // =====================================================
    // VERIFY / REJECT DOCUMENT
    // =====================================================

    async function DocumentVerified(selectedUserId, type) {

        if (!selectedUserId) {
            showToastFailed("Selected user ID not found");
            return;
        }

        try {

            setIsLoading(true);

            const request = new DocumentRequest();

            // Selected user's ID
            request.user_Id = selectedUserId;

            // 0 = Verified
            // 2 = Rejected
            request.type = parseInt(type);
            request.documentStatus = parseInt(type);

            console.log(
                "Verification Selected User ID:",
                selectedUserId
            );

            console.log(
                "Verification Request:",
                JSON.stringify(request)
            );

            const response = await axios.put(
                ApiConfig.getUrl("User/Update_Document_Status"),
                JSON.stringify(request),
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            console.log(
                "Verification Response:",
                response.data
            );

            const api = ApiResponse.fromJson(response.data);

            console.log(
                "Verification Status Code:",
                api.statusCode
            );

            // =================================================
            // SUCCESS
            // =================================================

            if (api.statusCode === 200) {

                if (api.response) {

                    const documentstatus =
                        DocumentstatusResponse.fromJson(
                            api.response
                        );

                    setProfile(documentstatus);
                }

                showToast(
                    api.message || "Document status updated successfully"
                );



                if (onRefresh) {
                    await onRefresh(selectedUserId);
                }

            } else {

                setProfile([]);

                showToastFailed(
                    api.message ||
                    api.errorMessage ||
                    "Document update failed"
                );
            }

        } catch (error) {

            setProfile([]);

            console.error(
                "Verification Error:",
                error
            );

            showToastFailed(
                error?.response?.data?.message ||
                error?.response?.data?.errorMessage ||
                "Document update failed"
            );

        } finally {

            setIsLoading(false);

        }
    }

    // =====================================================
    // DELETE DOCUMENT
    // =====================================================

    async function DeleteDocument(selectedUserId, documentId) {

        if (!selectedUserId) {
            showToastFailed("Selected user ID not found");
            return;
        }

        if (!documentId) {
            showToastFailed("Document ID not found");
            return;
        }

        try {

            setIsLoading(true);

            const request = {
                userId: selectedUserId,
                documentId: documentId
            };

            console.log("DELETE REQUEST:", request);

            const response = await axios.delete(
                ApiConfig.getUrl("User/documentDelete"),
                {
                    data: request,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            console.log("DELETE RESPONSE:", response.data);

            const api = ApiResponse.fromJson(response.data);

            if (
                api.statusCode === 200 &&
                api.status === true
            ) {

                showToast(
                    api.message ||
                    "Document deleted successfully"
                );

                if (onRefresh) {
                    await onRefresh(selectedUserId);
                }

            } else {

                showToastFailed(
                    api.message ||
                    api.errorMessage ||
                    "Document delete failed"
                );
            }

        } catch (error) {

            console.error("DELETE ERROR:", error);
            console.error(
                "DELETE RESPONSE:",
                error?.response?.data
            );

            showToastFailed(
                error?.response?.data?.message ||
                error?.response?.data?.errorMessage ||
                "Document delete failed"
            );

        } finally {
            setIsLoading(false);
        }
    }

    // =====================================================
    // DISABLE RIGHT CLICK
    // =====================================================

    const disableRightClick = (e) => {
        e.preventDefault();
    };

    // =====================================================
    // UI
    // =====================================================

    return (
        <div onContextMenu={disableRightClick}>

            <ToastContainer />

            {/* ===============================================
             SELECTED USER
         =============================================== */}

            {userData?.user_Id && (
                <div
                    style={{
                        marginBottom: "15px",
                        fontWeight: "bold"
                    }}
                >
                    Selected User ID: {userData.user_Id}
                </div>
            )}

            {/* ===============================================
             DOCUMENT LIST
         =============================================== */}

            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px"
                }}
            >

                {documentList.length > 0 ? (

                    documentList.map((img, index) => (

                        <div
                            key={img.id || index}
                            className="position-relative"
                            style={{
                                width: "200px",
                                height: "200px"
                            }}
                        >

                            <img
                                src={img.documentPath}
                                alt="Document"
                                className="img-thumbnail w-100 h-100"
                                style={{
                                    objectFit: "cover",
                                    borderRadius: "10px",
                                    boxShadow:
                                        "0 4px 10px rgba(255, 140, 0, 0.25)"
                                }}
                            />

                            <button
                                type="button"
                                className="btn btn-danger btn-sm position-absolute top-0 end-0 rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                    width: "25px",
                                    height: "25px",
                                    padding: 0,
                                    zIndex: 10
                                }}
                                disabled={isLoading}
                                onClick={() => {
                                    DeleteDocument(
                                        userData?.user_Id,
                                        img?.id
                                    );
                                }}
                            >
                                ×
                            </button>

                        </div>

                    ))

                ) : (

                    <div
                        style={{
                            width: "100%",
                            textAlign: "center",
                            padding: "30px",
                            color: "gray"
                        }}
                    >
                        No documents found
                    </div>

                )}

            </div>

            {/* ===============================================
             LOADER
         =============================================== */}

            {isLoading && (
                <div className="loader-overlay">

                    <Oval
                        height={60}
                        width={60}
                        color="#ffffff"
                        secondaryColor="#cccccc"
                        strokeWidth={4}
                        visible={true}
                    />

                </div>
            )}

            {/* ===============================================
             VERIFY / REJECT BUTTONS
         =============================================== */}

            <div
                style={{
                    marginTop: "20px"
                }}
            >

                {/* VERIFY */}

                <button
                    type="button"
                    onClick={() =>
                        DocumentVerified(
                            userData?.user_Id,
                            0
                        )
                    }
                    disabled={
                        isLoading ||
                        !userData?.user_Id
                    }
                    style={{
                        backgroundColor: "green",
                        color: "white",
                        border: "none",
                        padding: "8px 15px",
                        marginRight: "10px"
                    }}
                >
                    Verify
                </button>

                {/* REJECT */}

                <button
                    type="button"
                    onClick={() =>
                        DocumentVerified(
                            userData?.user_Id,
                            2
                        )
                    }
                    disabled={
                        isLoading ||
                        !userData?.user_Id
                    }
                    style={{
                        backgroundColor: "red",
                        color: "white",
                        border: "none",
                        padding: "8px 15px"
                    }}
                >
                    Rejected
                </button>

            </div>

        </div>
    );
}

export default Documentpopup;